import { render, staticRenderFns } from "./OpportunityStartups.vue?vue&type=template&id=3608c878&"
import script from "./OpportunityStartups.vue?vue&type=script&lang=js&"
export * from "./OpportunityStartups.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityStartups.vue?vue&type=style&index=0&id=3608c878&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports